module.exports = __webpack_public_path__ + "static/media/joz_thumb_even.1dcce4f7.jpg";